const Settings = {
    // TODO
    STEP: 75,
    SIZE: 50, // should not be greater than STEP
    COIN_SIZE: 10, // should not be greater than STEP
    BORDER: 10 * 2,
    TOP_SCORE_BOARD_HEIGHT: 50,
    GHOST_PER_X_POINTS: 20,
    SPEED_OF_GHOST: 1750,
}

export default Settings;